import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Enter = () => {
    document.title = "Daxilolma";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Daxilolma", value: "/products/enter", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Daxilolma</h2>
                    <p>
                        Məhsulları anbara daxil etmək üçün nəzərdə tutulub. Bunun üçün yeni daxilolma sənədi yaratmaq lazımdır. Ardıcıllıq nümunədə göstərilib.
                        Açılmış pəncərədə məhsulları axtarış xanasından əlavə edib, sayını yazmaq lazımdır. Bu zaman qiyməti də dəyişmək olur. Əlavə xərc
                        hissəsində yazılacaq məbləğ mayanın formalaşmasına təsir edəcək. Məsələn, məhsulun anbara daxil olması zamanı logistika və ya Gömrük
                        xərclərini əlavə xərc hissəsində qeyd etsəniz, ümumi xərc, məhsullar arasında proporsional qaydada bölünəcək (qiyməti az olan məhsulun
                        üzərinə az, cox olan məhsula isə çox əlavə olunacaq) və maya dəyəri formalaşacaq
                    </p>
                    <img src="/images/products/documents/enter.gif" alt="Daxilolma" />
                </article>
            </div>
        </div>
    );
};
